import { Formik, Field, FormikHelpers } from "formik";
import * as yup from "yup";
import { Input } from "../common/Input";
import { Button } from "../common/Button";
import styles from "./InviteStartups.module.scss";

interface InviteStartupValues {
  entrepreneur: string;
  startup: string;
  sector: string;
  email: string;
  phoneNumber: string;
}

const initialeFormValues = {
  entrepreneur: "",
  startup: "",
  sector: "",
  email: "",
  phoneNumber: "",
};

const validationSchema = yup.object().shape({
  entrepreneur: yup
    .string()
    .matches(/^[aA-zZ\s]+$/)
    .required(),
  startup: yup
    .string()
    .matches(/^[aA-zZ\s]+$/)
    .required(),
  sector: yup.string().matches(/^[aA-zZ\s]+$/),
  email: yup.string().email().required(),
  phoneNumber: yup.string(),
});

export const InviteStartup = () => {
  return (
    <div className={styles.wrapper}>
      <h2 className={styles.title}>
        VERSTUUR EEN UITNODIGING - MELD JOUW START UP AAN
      </h2>
      <p className={styles.text}>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
        tempor incididunt ut labore et dolore magna aliqua.
      </p>
      <div className={styles.select}>
        <button className={styles.button}>
          <div className={styles.selectedItem}>
            Editie 18 | 22 juni - 24 augustus 2022
          </div>
          <div className={styles.arrow}>
            <img src='/assets/arrow_white.svg' alt='arrow' />
          </div>
        </button>
      </div>
      <Formik
        validationSchema={validationSchema}
        initialValues={initialeFormValues}
        onSubmit={(
          values: InviteStartupValues,
          { resetForm }: FormikHelpers<InviteStartupValues>
        ) => {
          resetForm();
        }}
      >
        {({ values, errors, touched, handleChange, handleSubmit }) => (
          <form className={styles.formContainer} onSubmit={handleSubmit}>
            <div className={styles.entrepreneurContainer}>
              <Field
                name='entrepreneur'
                as={Input}
                type='text'
                placeholder='*Ondernemer:'
                onChange={handleChange}
                value={values.entrepreneur}
              />
            </div>
            <div className={styles.startupContainer}>
              <Field
                name='startup'
                as={Input}
                type='text'
                placeholder='*Startup:'
                onChange={handleChange}
                value={values.startup}
              />
            </div>
            <div className={styles.sectorContainer}>
              <Field
                name='sector'
                as={Input}
                type='text'
                placeholder='Sector:'
                onChange={handleChange}
                value={values.sector}
              />
            </div>
            <div className={styles.emailContainer}>
              <Field
                name='email'
                as={Input}
                type='text'
                placeholder='*Mail:'
                onChange={handleChange}
                value={values.email}
              />
            </div>
            <div className={styles.phoneContainer}>
              <Field
                name='phoneNumber'
                as={Input}
                type='text'
                placeholder='Telefoonnummer:'
                onChange={handleChange}
                value={values.phoneNumber}
              />
            </div>
            <Button type='submit' className='dark'>
              Uitnodigen
            </Button>
          </form>
        )}
      </Formik>
    </div>
  );
};
